import React from "react"
import Typography from "aldoo-ra/Typography"
import DropDownSelect from "aldoo-ra/DropdownSelect"

const SelectPropertyEditor = ({
  property,
  value,
  onChange,
  propertyConfig,
  className = ""
}) => {

  if (!property || !propertyConfig) return null

  const handleChange = (selected) => {
    const selectedValue = Array.isArray(selected) ? selected[0]?.value : selected?.value
    onChange?.(property, selectedValue)
  }

  const selectedOption = propertyConfig.options?.find(opt => opt.value === (value || '')) || { value: '', name: 'Default' }

  return (
    <div className={`space-y-2 ${className}`}>
      <Typography
        variant="admin_body_small"
        className="font-medium capitalize text-admin_text_secondary text-sm"
      >
        {propertyConfig.label || property}
      </Typography>
      <DropDownSelect
        variant="admin"
        searchEnabled={true}
        options={propertyConfig.options || []}
        value={selectedOption}
        onChange={handleChange}
        placeholder={propertyConfig.placeholder || `Select ${propertyConfig.label || property}`}
      />
    </div>
  )
}

export default SelectPropertyEditor